module.exports = __webpack_public_path__ + "img/kex-logo-mobile.36d44553.svg";